import { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { Button } from '@gto/ui/button'

import { TextareaField } from '@/components/form'
import { MutationError } from '@/components/mutation-error'

import { RailSection } from './rail-section'
import { usePartnerUpdate } from './use-partner-update'

type NotesSectionProps = { notes: string; partnerId: string }

export const NotesSection = ({ notes, partnerId }: NotesSectionProps) => {
  const { formatMessage } = useIntl()
  const [value, setValue] = useState(notes)
  const { mutation, hasError } = usePartnerUpdate(partnerId, () => undefined)

  const dirty = value !== notes

  return (
    <RailSection
      // flex-1 + the h-full chain below stretch the textarea to absorb all
      // remaining rail height (min 96px) — the rail's former dead bottom is
      // now writing room. With `rows` set, MUI skips TextareaAutosize and
      // leaves the height to CSS. On md the rail is content-height, so flex-1
      // has no slack and the textarea sits at its 96px floor.
      className="min-h-0 flex-1"
      title={formatMessage({ id: 'admin.partnerDetail.notes' })}
    >
      <TextareaField
        className="flex min-h-0 flex-1 flex-col"
        data-tst="partner-notes"
        placeholder={formatMessage({ id: 'admin.partnerDetail.notesPlaceholder' })}
        rows={3}
        textareaClassName="min-h-[96px] flex-1 [&_textarea]:h-full"
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
      <MutationError
        messageId="admin.partnerDetail.save.error"
        show={hasError}
      />
      <Button
        className="w-fit"
        data-tst="partner-notes-save"
        disabled={!dirty || mutation.isPending}
        size="small"
        variant="outlined"
        onClick={() => mutation.mutate({ partnerId, data: { notes: value } })}
      >
        <FormattedMessage id="admin.common.save" />
      </Button>
    </RailSection>
  )
}
